module.exports = __webpack_public_path__ + "img/error404.187f95fc.jpg";